import { InputRange } from '@abb-procure/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  DEFAULT_MAX_RANGE,
  DEFAULT_MIN_RANGE,
  DEFAULT_RANGE_STEP,
} from '../../constants';
import { SearchFilterValueDto } from '../../types/search-filter-value-dto.type';
import { parseNumber } from '../../utils/parse-number.util';

@Component({
  selector: 'procure-search-filter-range',
  templateUrl: './search-filter-range.component.html',
  imports: [InputRange],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchFilterRange {
  readonly label = input.required<string>();
  readonly control = input.required<FormGroup>();
  readonly options = input.required<SearchFilterValueDto[] | null>();

  protected readonly min = computed(
    () => parseNumber(this.options(), 'min') ?? DEFAULT_MIN_RANGE,
  );

  protected readonly max = computed(
    () => parseNumber(this.options(), 'max') ?? DEFAULT_MAX_RANGE,
  );

  protected readonly step = computed(
    () => parseNumber(this.options(), 'step') ?? DEFAULT_RANGE_STEP,
  );
}
